var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDDB32;}\n\t.st1{fill:#191E3B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.9,99H21.1C10,99,1,90,1,78.8V21.1C1,10,10,1,21.1,1h57.7C90,1,99,10,99,21.1v57.7C99.1,90,90,99,78.9,99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,80v-9.5c0-0.8-0.6-1.4-1.4-1.4H20c-0.8,0-1.4,0.6-1.4,1.4V80c0,0.8,0.6,1.4,1.4,1.4h9.5 C30.3,81.3,30.9,80.7,30.9,80z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,71.8V24.9c0-3.5-2.8-6.3-6.3-6.3H28.2c-0.9,0-1.5,0.3-2.1,0.9L16.7,29c-0.7,0.7-0.2,1.7,0.8,1.7H60 L33.7,57C33.2,57.5,33,58,33,58.7v6.9c0,0.8,0.6,1.4,1.4,1.4h6.9c0.8,0,1.3-0.2,1.7-0.7l26.3-26.3v42.4c0,1,1,1.5,1.7,0.8l9.4-9.4 C81,73.3,81.4,72.7,81.4,71.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.47125772a003aa4d211894b72253548a.svg";
export { ForwardRef as ReactComponent };